import { ErrorState } from "@/shared/components/ui/ErrorState";
import { ItemList } from "@/shared/components/ui/ItemList";
import { type Notification } from "../types/notificationTypes";
import { NotificationCard } from "./NotificationCard";

interface NotificationsListProps {
  notifications: Notification[];
  isLoading: boolean;
  error?: Error | null;
  unreadOnly?: boolean;
  onRetry: () => void;
}

export function NotificationsList({
  notifications,
  isLoading,
  error,
  unreadOnly = false,
  onRetry,
}: NotificationsListProps) {
  if (error) {
    return (
      <ErrorState
        title="Couldn't load notifications"
        message={error.message}
        onRetry={onRetry}
      />
    );
  }

  return (
    <ItemList
      className="gap-2"
      items={notifications}
      isLoading={isLoading}
      divided={false}
      loadingText="Loading notifications..."
      emptyState={{
        title: unreadOnly ? "You're all caught up" : "No notifications yet",
        message: unreadOnly
          ? "Switch to All to see read notifications."
          : "Booking updates and message notifications will appear here.",
      }}
      renderItem={(notification) => <NotificationCard notification={notification} />}
    />
  );
}
